import '../styles/GlobalDesign.css';
import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="home-container">
      {/* Navbar identique à la page d'accueil */}
      <nav className="navbar">
        <div className="navbar-brand">
          <Link to="/">
            <img 
              src="/logo.png"
              alt="Fluxivo Logo" 
              className="navbar-logo"
            />
            <span className="logo">Flux<span style={{color:'#22C55E'}}>ivo</span></span>
          </Link>
        </div>
        <div className="nav-links">
          <Link to="/">Accueil</Link>
          <Link to="/how-it-works">Comment ça marche</Link>
          <Link to="/privacy" className="active">Confidentialité</Link>
        </div>
      </nav>

      {/* Contenu de la page */}
      <div className="legal-page-content">
        <div className="legal-container">
          <h1>Politique de confidentialité</h1>
          <p className="last-update">Dernière mise à jour : 2026</p>

          <p className="intro">
            La présente politique de confidentialité décrit comment Fluxivo collecte, utilise et protège 
            les informations personnelles des utilisateurs de son site web et de ses services IPTV.
          </p>

          <section>
            <h2>1. Informations que nous collectons</h2>
            <p>Lorsque vous utilisez notre site ou passez une commande, nous pouvons collecter les informations suivantes :</p>
            <ul>
              <li>Nom ou pseudo</li>
              <li>Adresse e-mail</li>
              <li>Informations de contact fournies volontairement</li>
              <li>Informations relatives à la commande (type d'abonnement, durée)</li>
              <li>Informations techniques non personnelles (type d'appareil, navigateur, adresse IP approximative)</li>
            </ul>
            <p>
              Nous ne collectons pas d'informations sensibles telles que les données bancaires complètes, 
              mots de passe personnels ou informations d'identité officielle.
            </p>
          </section>

          <section>
            <h2>2. Utilisation des informations</h2>
            <p>Les informations collectées sont utilisées uniquement pour :</p>
            <ul>
              <li>Traiter et activer votre abonnement IPTV</li>
              <li>Vous envoyer votre lien M3U ou vos informations d'accès</li>
              <li>Fournir une assistance client et un support technique</li>
              <li>Améliorer la qualité de nos services et de notre site</li>
              <li>Vous informer d'offres ou mises à jour (si vous y avez consenti)</li>
            </ul>
          </section>

          <section>
            <h2>3. Partage des informations</h2>
            <p>Fluxivo s'engage à ne pas vendre, louer ou partager vos informations personnelles à des tiers, sauf dans les cas suivants :</p>
            <ul>
              <li>Lorsque cela est nécessaire pour fournir le service demandé</li>
              <li>Si la loi l'exige ou dans le cadre d'une obligation légale</li>
              <li>Pour protéger nos droits, notre sécurité ou celle de nos utilisateurs</li>
            </ul>
          </section>

          <section>
            <h2>4. Cookies et technologies similaires</h2>
            <p>Notre site peut utiliser des cookies ou technologies similaires afin de :</p>
            <ul>
              <li>Améliorer l'expérience utilisateur</li>
              <li>Analyser le trafic et l'utilisation du site</li>
              <li>Mémoriser certaines préférences</li>
            </ul>
            <p>Vous pouvez désactiver les cookies à tout moment depuis les paramètres de votre navigateur.</p>
          </section>

          <section>
            <h2>5. Sécurité des données</h2>
            <p>
              Nous mettons en place des mesures de sécurité techniques et organisationnelles afin de protéger 
              vos informations contre tout accès non autorisé, perte ou divulgation.
            </p>
            <p>
              Cependant, aucune transmission sur Internet n'est totalement sécurisée. L'utilisation de notre 
              site se fait donc à vos propres risques.
            </p>
          </section>

          <section>
            <h2>6. Responsabilité et utilisation du service</h2>
            <p>
              Fluxivo est une plateforme de service TV par internet. L'utilisateur est seul responsable 
              de l'utilisation qu'il fait du service conformément aux lois en vigueur dans son pays.
            </p>
            <p>
              Nous encourageons tous les utilisateurs à s'assurer que l'utilisation du service est conforme 
              à la réglementation locale.
            </p>
          </section>

          <section>
            <h2>7. Liens externes</h2>
            <p>
              Notre site peut contenir des liens vers des sites tiers. Nous ne sommes pas responsables du 
              contenu ou des pratiques de confidentialité de ces sites externes.
            </p>
          </section>

          <section>
            <h2>8. Vos droits</h2>
            <p>Vous disposez des droits suivants concernant vos données personnelles :</p>
            <ul>
              <li>Droit d'accès</li>
              <li>Droit de rectification</li>
              <li>Droit de suppression</li>
            </ul>
            <p>Pour exercer ces droits, vous pouvez nous contacter via les informations ci-dessous.</p>
          </section>

          <section>
            <h2>9. Modifications de la politique</h2>
            <p>
              Fluxivo se réserve le droit de modifier cette politique de confidentialité à tout moment. 
              Toute modification sera publiée sur cette page.
            </p>
          </section>

          <section>
            <h2>10. Contact</h2>
            <p>Pour toute question concernant cette politique de confidentialité ou vos données personnelles, vous pouvez nous contacter via :</p>
            <p className="contact-info">
              <strong>Email :</strong> support@fluxivo.com
            </p>
          </section>
        </div>
      </div>

      {/* Footer identique à la page d'accueil */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">Fluxivo</div>
            <p>Service de streaming IPTV Premium</p>
          </div>
          <div className="footer-section">
            <h4>Liens rapides</h4>
            <a href="/">Accueil</a>
            <a href="/how-it-works">Comment ça marche</a>
            <a href="/privacy">Confidentialité</a>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>support@fluxivo.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Fluxivo. Tous droits réservés.</p>
          <p>+20,000 chaînes • Qualité HD/4K • Support 24/7</p>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
